import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Icon from '../../../Icon';
import { Device } from '../Device';
import { PROFILE } from '../../../../constants/strings';
import { COLORS } from '../../../../constants/styles';
import { formatToCalendarTime } from '../../../PatientHealthboard/utils';
import { DEVICE_CALENDAR_FORMATS } from '../../../PatientHealthboard/constants';
import styles from './index.styl';

export const Account = ({
  account: { provider, id, requestFailed, providerEmail, syncedAt, userName },
  connectedDevices,
  setShowRemoveConfirmation,
  setCurrentAccount,
  noPermissionToAccount,
}) => {
  const handleRemoveAccount = () => {
    setCurrentAccount(id);
    setShowRemoveConfirmation(true);
  };

  return (
    <div className={styles.root}>
      <div className={styles.headerWrapper}>
        <div className={styles.nameAccount}>
          <FormattedMessage
            {...PROFILE.deviceSetup.detailsAccount}
            values={{ name: provider.name }}
          />
        </div>
        <div
          className={styles.removeAccount}
          onClick={() => handleRemoveAccount()}
        >
          <FormattedMessage {...PROFILE.deviceSetup.removeAccount} />
        </div>
      </div>
      <div className={styles.content}>
        {connectedDevices.length === 0 &&
          (noPermissionToAccount || requestFailed) && (
            <div className={styles.noPermission}>
              <div className={styles.iconNoPermission}>
                <Icon
                  name="exclamation-mark-hover"
                  size={16}
                  style={{ fill: COLORS.orangePink }}
                />
              </div>
              <div className={styles.noPermissionDescription}>
                {requestFailed ? (
                  <FormattedMessage
                    {...PROFILE.deviceSetup.error}
                    values={{ type: provider.name }}
                  />
                ) : (
                  <FormattedMessage
                    {...PROFILE.deviceSetup.noPermission}
                    values={{ type: provider.name }}
                  />
                )}
                <span className={styles.noPermissionAnnotation}>
                  <FormattedMessage
                    {...PROFILE.deviceSetup.noPermissionAnnotation}
                  />
                </span>
              </div>
            </div>
          )}
        {connectedDevices.length === 0 &&
          !noPermissionToAccount &&
          !requestFailed &&
          (providerEmail || userName ? (
            <div className={styles.googleFitWrapper}>
              <div className={styles.email}>{providerEmail || userName}</div>
              <div className={styles.syncedDate}>
                <FormattedMessage {...PROFILE.deviceSetup.synced} />
                {formatToCalendarTime(syncedAt, false, DEVICE_CALENDAR_FORMATS)}
              </div>
            </div>
          ) : (
            <span className={styles.noDevices}>
              <FormattedMessage {...PROFILE.deviceSetup.noDevices} />
            </span>
          ))}
        {connectedDevices.length !== 0 &&
          connectedDevices
            .filter(device => device.providerCode === provider.code)
            .map((device, index) => {
              if (index >= 1 && (providerEmail || userName)) return;
              return (
                <Device
                  device={device}
                  key={device.externalId}
                  providerEmail={providerEmail || userName}
                />
              );
            })}
      </div>
    </div>
  );
};

Account.propTypes = {
  account: PropTypes.object,
  connectedDevices: PropTypes.array,
  setShowRemoveConfirmation: PropTypes.func,
  setCurrentAccount: PropTypes.func,
  noPermissionToAccount: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/DeviceSetup/Account/index.jsx